import { render } from "./depositoefectivo.vue?vue&type=template&id=836120da&scoped=true"
import script from "./depositoefectivo.vue?vue&type=script&lang=js"
export * from "./depositoefectivo.vue?vue&type=script&lang=js"

import "./depositoefectivo.vue?vue&type=style&index=0&id=836120da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-836120da"]])

export default __exports__